














import { Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoadingModal extends Vue {

  @Getter('app/hasBlockingRequests') public hasBlockingRequests: boolean;

}
